module.exports = __webpack_public_path__ + "static/media/footerb.5ef993d9.svg";